import { LoadingButton } from "@mui/lab";
import { Divider, Stack } from "@mui/material";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import {
    FolderDto,
    ProjectDetailDto,
    ProjectDto,
    ProjectService,
} from "../../../api/psc";
import {
    DialogContainer,
    DialogHeader,
    EmptyListMessage,
} from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import { RootState } from "../../../slices/Store";
import SelectFolderItem from "../../project-detail/Shared/SelectFolderItem";

export default function SelectFolderForBatchDialog(props: {
    projects: ProjectDto[] | ProjectDetailDto[];
    onMoved: () => void;
}) {
    const { openDialog, closeDialog } = useContext(DialogContext);
    const sharedState = useSelector((state: RootState) => state.shared);

    const [selectedFolderIds, setSelectedFolderIds] = useState<number[]>([]);
    const [requestInProgress, setRequestInProgress] = useState(false);

    const toggleFolderInProject = (folder: FolderDto) => {
        const updatedFolderIds = [...selectedFolderIds];

        if (selectedFolderIds.includes(folder.id)) {
            const index = selectedFolderIds.indexOf(folder.id);
            updatedFolderIds.splice(index, 1);
        } else {
            updatedFolderIds.push(folder.id);
        }

        setSelectedFolderIds(updatedFolderIds);
    };

    const applyChanges = () => {
        setRequestInProgress(true);
        ProjectService.batchUpdateProjectFolders("1", {
            folderIds: selectedFolderIds,
            projectHashIds: props.projects.map((p) => p.hashId),
        }).then((r) => {
            setRequestInProgress(false);
            closeDialog();
            props.onMoved();
        });
    };

    return (
        <DialogContainer>
            <DialogHeader title="انتخاب پوشه" />

            <Stack sx={{ p: 2 }} spacing={2}>
                {sharedState.folders.length === 0 && (
                    <EmptyListMessage message="پوشه ای یافت نشد" />
                )}

                <Stack divider={<Divider />}>
                    {sharedState.folders.map((f, i) => (
                        <SelectFolderItem
                            key={f.id}
                            folder={f}
                            checked={selectedFolderIds.includes(f.id)}
                            onToggle={toggleFolderInProject}
                        />
                    ))}
                </Stack>

                <Divider />

                <LoadingButton
                    fullWidth
                    disabled={selectedFolderIds.length === 0}
                    loading={requestInProgress}
                    variant="contained"
                    onClick={applyChanges}
                >
                    ذخیره تغییرات
                </LoadingButton>
            </Stack>
        </DialogContainer>
    );
}
